import React, { ReactNode } from 'react'
import { Box } from 'grommet'

export const ControlButtons = ({children}: { children: ReactNode }) => (
    <Box direction='row' justify='end' gap='small' pad={{top: 'medium'}}>
        {children}
    </Box>
)
